export const deferred = () => {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return {
        resolve,
        reject,
        promise
    };
};
export const delayPromise = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
